import axios from "axios";
import { Urls } from "../../../store/urls";

export const getCmsProductListDialer = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CMS_PRODUCT_LIST_API,
        params: params,
    });
};

export const postCmsProductDialer = (data) => {
    return axios({
        method: "POST",
        url: Urls.POST_CMS_PRODUCT_LIST_API,
        data: data,
    });
};
